import { CircularProgress } from '@mui/material';

export const MFELoading = () => (
  <div className="flex flex-1 w-full h-full items-center justify-center">
    <CircularProgress />
  </div>
);
